const Webex = require("webex");


const urlParams = new URLSearchParams(window.location.search);
const consultId = urlParams.get('consult_id');
const patientId = urlParams.get('patient_id');
const doctorId = urlParams.get('doctor_id');
const database = urlParams.get('db');
const doctorName = urlParams.get('doctor_name');
const patientName = urlParams.get('patient_name');


// Logs temporariamente habilitados para debug
// console.log = function () {};
// console.error = function () {};
// console.warn = function () {}; 

let isMuted = false;
let isCameraOn = true;
var doctorSocket = null;
var patientSocket = null;
var webex;
var meetings;
var currentMeeting = null; // Referência da reunião atual
var microphoneStream = null; // Stream do microfone
var cameraStream = null; // Stream da câmera
var isUnregistered = false; // Flag para evitar múltiplas tentativas de desregistro

// Variáveis para controle de estado e dados dinâmicos
var isWebexReady = false;
var currentDoctorData = null;
var currentPatientData = null;
var consultationStartTime = null;
var consultationEndTime = null;

// Função centralizada para desregistrar meetings de forma segura
async function safeUnregisterMeeting() {
  if (isUnregistered || !meetings) {
    return;
  }
  
  try {
    isUnregistered = true;
    await meetings.unregister();
    console.log("Reunião desregistrada com sucesso");
  } catch (error) {
    console.error("Erro ao desregistrar reunião:", error);
  }
}

// Função para desregistrar de forma síncrona em situações críticas
function syncUnregisterMeeting() {
  if (isUnregistered || !meetings) {
    return;
  }
  
  try {
    isUnregistered = true;
    // Chamada síncrona para situações onde não podemos aguardar promises
    meetings.unregister();
    console.log("Reunião desregistrada sincronamente");
  } catch (error) {
    console.error("Erro ao desregistrar reunião sincronamente:", error);
  }
}

async function initializeWebex() {
  try {
    console.log('🚀 Initializing Webex...');
    
    // Buscar dados dinâmicos
    currentDoctorData = await getDoctorData(doctorId, database);
    currentPatientData = await getPatientData(patientId, database);
    
    // Atualizar interface com os dados
    updateDoctorInfo(currentDoctorData);
    updatePatientInfo(currentPatientData);
    
    const myAccessToken = await getAccessToken(doctorId, database);
    console.log('🔑 Access token obtained');

    webex = Webex.init({
      credentials: {
        access_token: myAccessToken,
      },
      config: {
        meetings: {
          displayName: "Paciente", // Nome genérico
          enableDisplayNameOverride: true
        }
      }
    });

    meetings = webex.meetings;
    webex.config.logger.level = "debug";

    await meetings.register();
    console.log('✅ Webex registered successfully');
    
    // Habilitar sala de reunião
    enableMeetingRoom();

    // Múltiplos event listeners para garantir desregistro em várias situações
    
    // 1. Antes da página ser fechada (mais tempo para executar)
    window.addEventListener("beforeunload", (event) => {
      syncUnregisterMeeting();
      console.log("Reunião desregistrada ao sair da página (beforeunload).");
    });

    // 2. Quando a página está sendo descarregada (backup do beforeunload)
    window.addEventListener("unload", (event) => {
      syncUnregisterMeeting();
      console.log("Reunião desregistrada ao descarregar página (unload).");
    });


    // 5. Quando há desconexão de rede
    window.addEventListener("offline", async () => {
      await safeUnregisterMeeting();
      console.log("Reunião desregistrada - conexão perdida.");
    });

    // 6. Quando há mudança no foco da janela (perda de foco pode indicar fechamento)
    let focusTimer;

    window.addEventListener("focus", () => {
      if (focusTimer) {
        clearTimeout(focusTimer);
        focusTimer = null;
      }
    });

    // 7. Tratamento para erros não capturados que podem indicar problemas críticos
    window.addEventListener("error", async (event) => {
      console.error("Erro crítico detectado:", event.error);
      await safeUnregisterMeeting();
      console.log("Reunião desregistrada devido a erro crítico.");
    });

    // 8. Tratamento para promises rejeitadas não capturadas
    window.addEventListener("unhandledrejection", async (event) => {
      console.error("Promise rejeitada não tratada:", event.reason);
      await safeUnregisterMeeting();
      console.log("Reunião desregistrada devido a promise rejeitada.");
    });

    console.log("Webex inicializado com sucesso!");

  } catch (error) {
    console.error("❌ Erro ao inicializar o Webex:", error);
    showMeetingError(error.message || 'Erro desconhecido na inicialização');
    // Tentar desregistrar mesmo em caso de erro na inicialização
    await safeUnregisterMeeting();
  }
}

function resampleAudioBuffer(inputBuffer, originalSampleRate, targetSampleRate) {
  const ratio = originalSampleRate / targetSampleRate;
  const outputLength = Math.ceil(inputBuffer.length / ratio);
  const resampledBuffer = new Float32Array(outputLength);

  for (let i = 0; i < outputLength; i++) {
    const sourceIndex = i * ratio;
    const intSourceIndex = Math.floor(sourceIndex);
    const fraction = sourceIndex - intSourceIndex;

    const nextIndex = intSourceIndex + 1 < inputBuffer.length ? intSourceIndex + 1 : intSourceIndex;
    resampledBuffer[i] = (1 - fraction) * inputBuffer[intSourceIndex] + fraction * inputBuffer[nextIndex];
  }

  return resampledBuffer;
}

function handleAudioStreamDoctor(stream) {
  doctorSocket = new WebSocket('wss://doctor-stream.doutor-ai.com:8888/out');
  websocket = doctorSocket;
  doctorSocket.onopen = () => {
    console.log('WebSocket connection opened doctor');
    const urlParams = new URLSearchParams(window.location.search);

      // Extraindo os parâmetros da URL
      const consultId = urlParams.get('consult_id');
      const patientId = urlParams.get('patient_id');
      const doctorId = urlParams.get('doctor_id');
      const database = urlParams.get('db');

    const initialMessage = {
      type: 'start',
      consult_id: consultId,
      patient_id: patientId,
      doctor_id: doctorId,
      db: database,
      timestamp: new Date().toISOString(),
      additionalInfo: 'Informações adicionais'
    };

    doctorSocket.send(JSON.stringify(initialMessage));
    console.log('Initial JSON message sent:', initialMessage);

    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const mediaStreamSource = audioContext.createMediaStreamSource(stream);

    const scriptProcessor = audioContext.createScriptProcessor(4096, 1, 1);  // Reduzido o tamanho do buffer
    mediaStreamSource.connect(scriptProcessor);
    scriptProcessor.connect(audioContext.destination);

    scriptProcessor.onaudioprocess = (audioProcessingEvent) => {
      const inputBuffer = audioProcessingEvent.inputBuffer.getChannelData(0);
      const resampledBuffer = resampleAudioBuffer(inputBuffer, audioContext.sampleRate, 16000);

      if (doctorSocket.readyState === WebSocket.OPEN) {
        const int16Array = new Int16Array(resampledBuffer.length);
        for (let i = 0; i < resampledBuffer.length; i++) {
          int16Array[i] = Math.min(1, Math.max(-1, resampledBuffer[i])) * 0x7FFF;
        }
        doctorSocket.send(int16Array);
        console.log('Raw audio data sent to WebSocket');
      } else {
        console.warn('WebSocket not open. ReadyState:', doctorSocket.readyState);
      }
    };
  };

  doctorSocket.onerror = (error) => {
    console.error('WebSocket error:', error);
  };

  doctorSocket.onclose = async () => {
    await safeUnregisterMeeting();
    console.log('WebSocket connection closed - reunião desregistrada');
  };
}
function handleAudioStreamPatient(stream) {
  patientSocket = new WebSocket('wss://patient-stream.doutor-ai.com:7777/out');
  websocket = patientSocket;
  patientSocket.onopen = () => {
    console.log('WebSocket connection opened');
    const urlParams = new URLSearchParams(window.location.search);

    // Extraindo os parâmetros da URL
    const consultId = urlParams.get('consult_id');
    const patientId = urlParams.get('patient_id');
    const doctorId = urlParams.get('doctor_id');
    const database = urlParams.get('db');

    const initialMessage = {
      type: 'start',
      consult_id: consultId,
      patient_id: patientId,
      doctor_id: doctorId,
      db: database,
      //bot_id: "homolog",
      timestamp: new Date().toISOString(),
      additionalInfo: 'Informações adicionais'
    };

    patientSocket.send(JSON.stringify(initialMessage));
    console.log('Initial JSON message sent:', initialMessage);

    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const mediaStreamSource = audioContext.createMediaStreamSource(stream);

    const scriptProcessor = audioContext.createScriptProcessor(4096, 1, 1);  // Reduzido o tamanho do buffer
    mediaStreamSource.connect(scriptProcessor);
    scriptProcessor.connect(audioContext.destination);

    scriptProcessor.onaudioprocess = (audioProcessingEvent) => {
      const inputBuffer = audioProcessingEvent.inputBuffer.getChannelData(0);
      const resampledBuffer = resampleAudioBuffer(inputBuffer, audioContext.sampleRate, 16000);

      if (patientSocket.readyState === WebSocket.OPEN) {
        const int16Array = new Int16Array(resampledBuffer.length);
        for (let i = 0; i < resampledBuffer.length; i++) {
          int16Array[i] = Math.min(1, Math.max(-1, resampledBuffer[i])) * 0x7FFF;
        }
        patientSocket.send(int16Array);
        console.log('Raw audio data sent to WebSocket');
      } else {
        console.warn('WebSocket not open. ReadyState:', patientSocket.readyState);
      }
    };
  };

  patientSocket.onerror = (error) => {
    console.error('WebSocket error:', error);
  };

  patientSocket.onclose = async () => {
    await meetings.unregister();
    console.log('WebSocket connection closed');
  };
}

// Função para alternar o estado do microfone
async function toggleMicrophone() {
  console.log('toggleMicrophone chamado - estado atual:', { isMuted, currentMeeting: !!currentMeeting, microphoneStream: !!microphoneStream });
  
  if (!microphoneStream || !microphoneStream.inputStream) {
    console.warn('Stream do microfone não disponível');
    return;
  }

  try {
    const audioTracks = microphoneStream.inputStream.getAudioTracks();
    console.log('Audio tracks encontradas:', audioTracks.length);
    
    if (audioTracks.length > 0) {
      if (isMuted) {
        // Desmutar microfone
        audioTracks.forEach(track => track.enabled = true);
        isMuted = false;
        updateMicrophoneButton();
        console.log('Microfone desmutado');
      } else {
        // Mutar microfone
        audioTracks.forEach(track => track.enabled = false);
        isMuted = true;
        updateMicrophoneButton();
        console.log('Microfone mutado');
      }
    } else {
      console.warn('Nenhuma track de áudio encontrada');
    }
  } catch (error) {
    console.error('Erro ao alternar microfone:', error);
  }
}

// Função para alternar o estado da câmera
async function toggleCamera() {
  console.log('toggleCamera chamado - estado atual:', { isCameraOn, currentMeeting: !!currentMeeting, cameraStream: !!cameraStream });
  
  if (!cameraStream || !cameraStream.inputStream) {
    console.warn('Stream da câmera não disponível');
    return;
  }

  try {
    const videoTracks = cameraStream.inputStream.getVideoTracks();
    console.log('Video tracks encontradas:', videoTracks.length);
    
    if (videoTracks.length > 0) {
      if (!isCameraOn) {
        // Ligar câmera
        videoTracks.forEach(track => track.enabled = true);
        document.getElementById("self-view").srcObject = cameraStream.inputStream;
        isCameraOn = true;
        updateCameraButton();
        console.log('Câmera ligada');
      } else {
        // Desligar câmera
        videoTracks.forEach(track => track.enabled = false);
        isCameraOn = false;
        updateCameraButton();
        console.log('Câmera desligada');
      }
    } else {
      console.warn('Nenhuma track de vídeo encontrada');
    }
  } catch (error) {
    console.error('Erro ao alternar câmera:', error);
  }
}

// Função para atualizar o visual do botão do microfone
function updateMicrophoneButton() {
  const button = document.getElementById("mute-audio");
  const icon = button.querySelector('i');
  
  if (isMuted) {
    button.classList.remove('bg-gray-600', 'hover:bg-gray-700');
    button.classList.add('bg-red-500', 'hover:bg-red-600');
    icon.classList.remove('ph-microphone');
    icon.classList.add('ph-microphone-slash');
  } else {
    button.classList.remove('bg-red-500', 'hover:bg-red-600');
    button.classList.add('bg-gray-600', 'hover:bg-gray-700');
    icon.classList.remove('ph-microphone-slash');
    icon.classList.add('ph-microphone');
  }
}

// Função para atualizar o visual do botão da câmera
function updateCameraButton() {
  const button = document.getElementById("mute-video");
  const icon = button.querySelector('i');
  
  if (!isCameraOn) {
    button.classList.remove('bg-gray-600', 'hover:bg-gray-700');
    button.classList.add('bg-red-500', 'hover:bg-red-600');
    icon.classList.remove('ph-video-camera');
    icon.classList.add('ph-video-camera-slash');
  } else {
    button.classList.remove('bg-red-500', 'hover:bg-red-600');
    button.classList.add('bg-gray-600', 'hover:bg-gray-700');
    icon.classList.remove('ph-video-camera-slash');
    icon.classList.add('ph-video-camera');
  }
}

async function bindMeetingEvents(meeting) {
  meeting.on("error", (err) => {
    console.error(err);
  });
  meeting.on("self:lobbyWaiting", (person) => {
    if (!person) {
      return;
    }
    console.log("person", person);
  });

  meeting.on("media:ready", (media) => {
    if (!media) {
      return;
    }
    if (media.type === "remoteVideo") {
      document.getElementById("remote-view-video").srcObject = media.stream;
    }
    if (media.type === "remoteAudio") {
      document.getElementById("remote-view-audio").srcObject = media.stream;
      const audioTracks = media.stream.getAudioTracks();
      if (audioTracks.length > 0) {
        console.log('Audio track found:', audioTracks[0]);
        //handleAudioStreamPatient(media.stream);
        const audioElement = document.createElement('audio');
        audioElement.srcObject = media.stream;
        audioElement.play()
        audioElement.muted = true;
        audioElement.style.display = 'none';
      } else {
        console.log('No audio tracks found in the MediaStream');
      }
    }
  });

  meeting.on("media:stopped", (media) => {
    if (media.type === "remoteVideo") {
      document.getElementById("remote-view-video").srcObject = null;
    }
    if (media.type === "remoteAudio") {
      document.getElementById("remote-view-audio").srcObject = null;
    }
  }); 

  document.getElementById("hangup").addEventListener("click", async () => {
    showHangupConfirmation();
  });
}

async function closeSockets() {
  await safeUnregisterMeeting();
}

async function joinMeeting(meeting) {
  // Armazenar referência da reunião atual
  currentMeeting = meeting;
  
  microphoneStream =
    await meetings.mediaHelpers.createMicrophoneStream({
      echoCancellation: true,
      noiseSuppression: true,
    });
  console.log("microphoneStream", microphoneStream.inputStream);
  
  try {
    cameraStream = await meetings.mediaHelpers.createCameraStream({
      width: 720,
      height: 400,
    });
    document.getElementById("self-view").srcObject = cameraStream.inputStream;
    isCameraOn = true; // Câmera inicia ligada
    isMuted = false; // Microfone inicia desmutado
  } catch (error) {
    console.warn("Erro ao criar o fluxo da câmera:", error);
    isCameraOn = false; // Câmera não disponível
  }

  const meetingOptions = {
    displayName: "", 
    showDisplayName: false,
    mediaOptions: {
      allowMediaInLobby: true,
      shareAudioEnabled: false,
      shareVideoEnabled: false,
      localStreams: {
        ...(cameraStream ? { camera: cameraStream } : {}),
        microphone: microphoneStream,
      },
    },
  };

  await meeting.joinWithMedia(meetingOptions);
}

document.getElementById("destination").addEventListener("submit", async (event) => {
  event.preventDefault();
  
  // Verificar se o Webex está pronto
  if (!isWebexReady) {
    console.log('⚠️ Webex not ready yet, ignoring click');
    return;
  }
  
  console.log('🚀 Starting consultation...');
  consultationStartTime = new Date();
  
  const urlParams = new URLSearchParams(window.location.search);
  const link = await getJoinLink(doctorId, consultId, database);
  console.log("linkMeeting", link);

  return meetings
    .create(link)
    .then(async (meeting) => {
      console.log("meeting", meeting);

      document.getElementById("destination").classList.add("hidden");
      document.getElementById("doctor-video").classList.remove("hidden");
      document.getElementById("hangup").classList.remove("hidden");
      document.getElementById("mute-audio").classList.remove("hidden");
      document.getElementById("mute-video").classList.remove("hidden");

      // Adicionar event listeners para os botões de controle de mídia
      console.log('Adicionando event listeners para botões de mídia');
      document.getElementById("mute-audio").addEventListener("click", () => {
        console.log('Clique no botão mute-audio detectado');
        toggleMicrophone();
      });
      document.getElementById("mute-video").addEventListener("click", () => {
        console.log('Clique no botão mute-video detectado');
        toggleCamera();
      });

      await bindMeetingEvents(meeting);

      await joinMeeting(meeting);
      
      // Inicializar estado visual dos botões
      updateMicrophoneButton();
      updateCameraButton();
    })
    .catch(async (error) => {
      //await closeSockets();
      //await meetings.unregister();
      console.error(error);
    });
});

async function getAccessToken(doctor_id, database = 'feluma') {
  const url = `https://api-feluma.doutor-ai.com/webhook/bd5b939b-e870-4d76-a28c-33f49110b622?doctor_id=${doctor_id}&db=${database}`;
  console.log('🔑 Fetching access token from:', url);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Erro na requisição: ${response.statusText}`);
    }

    const data = await response.json();
    return data.accessToken;
  } catch (error) {
    console.error('Erro ao obter accessToken:', error);
    throw error;
  }
}

async function getJoinLink(doctor_id, consult_id, database = 'feluma') {
  const url = `https://api-feluma.doutor-ai.com/webhook/d54ed8fc-2053-4db3-858b-3cbc0d207f19?doctor_id=${doctor_id}&consult_id=${consult_id}&db=${database}`;
  console.log('🔗 Fetching join link from:', url);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Erro na requisição: ${response.statusText}`);
    }

    const data = await response.json();
    return data.startLink;
  } catch (error) {
    console.error('Erro ao obter accessToken:', error);
    throw error;
  }
}

// Funções para buscar dados dinâmicos
async function getDoctorData(doctor_id, database = 'feluma') {
  try {
    const url = `https://api-feluma.doutor-ai.com/api/doctors/${doctor_id}?db=${database}`;
    console.log('👨‍⚕️ Fetching doctor data from:', url);
    
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const doctorData = await response.json();
    console.log('👨‍⚕️ Doctor data received:', doctorData);
    return doctorData;
  } catch (error) {
    console.log('👨‍⚕️ Fetch failed, using fallback doctor data');
    
    // Fallback: usar nome da URL ou padrão
    return {
      id: doctor_id,
      name: doctorName || 'Dr. Médico',
      specialty: 'Medicina Geral'
    };
  }
}

async function getPatientData(patient_id, database = 'feluma') {
  try {
    const url = `https://api-feluma.doutor-ai.com/api/patients/${patient_id}?db=${database}`;
    console.log('👤 Fetching patient data from:', url);
    
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const patientData = await response.json();
    console.log('👤 Patient data received:', patientData);
    return patientData;
  } catch (error) {
    console.log('👤 Fetch failed, using fallback patient data');
    
    // Fallback: usar nome da URL ou padrão
    return {
      id: patient_id,
      name: patientName || 'Paciente',
      email: 'paciente@exemplo.com'
    };
  }
}

// Funções para atualizar a interface
function updateDoctorInfo(doctorData) {
  const doctorNameElement = document.getElementById('doctor-name');
  if (doctorNameElement && doctorData) {
    doctorNameElement.textContent = `Dr. ${doctorData.name}`;
    console.log('👨‍⚕️ Doctor name updated:', doctorData.name);
  }
}

function updatePatientInfo(patientData) {
  const patientNameElement = document.getElementById('patient-name');
  if (patientNameElement && patientData) {
    patientNameElement.textContent = `Você (${patientData.name})`;
    console.log('👤 Patient name updated:', patientData.name);
  }
}

// Funções de controle de loading
function enableMeetingRoom() {
  console.log('✅ Webex ready, enabling meeting room');
  
  // Esconder loading
  const loadingState = document.getElementById('loading-state');
  if (loadingState) {
    loadingState.style.display = 'none';
  }
  
  // Mostrar feedback de sucesso por 2 segundos
  const successFeedback = document.createElement('div');
  successFeedback.className = 'flex flex-col items-center gap-4 animate-fade-in';
  successFeedback.innerHTML = `
    <div class="flex items-center gap-3 px-6 py-4 bg-green-600 text-white rounded-xl pulse-success">
      <i class="text-2xl ph-fill ph-check-circle"></i>
      <span class="text-lg font-medium">Consulta pronta!</span>
    </div>
  `;
  
  const createMeeting = document.getElementById('create-meeting');
  createMeeting.appendChild(successFeedback);
  
  setTimeout(() => {
    successFeedback.remove();
    
    // Mostrar botão de entrar
    const destinationForm = document.getElementById('destination');
    if (destinationForm) {
      destinationForm.classList.remove('hidden');
      destinationForm.classList.add('animate-fade-in');
    }
    
    isWebexReady = true;
  }, 2000);
}

function showMeetingError(message) {
  console.log('❌ Meeting error:', message);
  
  // Esconder loading
  const loadingState = document.getElementById('loading-state');
  if (loadingState) {
    loadingState.style.display = 'none';
  }
  
  // Mostrar erro
  const errorFeedback = document.createElement('div');
  errorFeedback.className = 'flex flex-col items-center gap-4 text-center';
  errorFeedback.innerHTML = `
    <div class="flex items-center gap-3 px-6 py-4 bg-red-600 text-white rounded-xl">
      <i class="text-2xl ph-fill ph-warning-circle"></i>
      <span class="text-lg font-medium">Erro ao preparar consulta</span>
    </div>
    <p class="text-white/70 text-sm">${message}</p>
    <button onclick="window.location.reload()" class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
      Tentar Novamente
    </button>
  `;
  
  const createMeeting = document.getElementById('create-meeting');
  createMeeting.appendChild(errorFeedback);
}

// Funções de controle de hangup
function showHangupConfirmation() {
  const modal = document.getElementById('hangup-confirmation');
  if (modal) {
    modal.classList.remove('hidden');
  }
}

function hideHangupConfirmation() {
  const modal = document.getElementById('hangup-confirmation');
  if (modal) {
    modal.classList.add('hidden');
  }
}

function getConsultationDuration() {
  if (consultationStartTime && consultationEndTime) {
    const duration = consultationEndTime - consultationStartTime;
    const minutes = Math.floor(duration / 60000);
    const seconds = Math.floor((duration % 60000) / 1000);
    return `Duração: ${minutes}m ${seconds}s`;
  }
  return '';
}

async function performHangup() {
  try {
    consultationEndTime = new Date();
    
    // Fechar sockets
    if (doctorSocket) {
      doctorSocket.close();
      doctorSocket = null;
    }
    if (patientSocket) {
      patientSocket.close();
      patientSocket = null;
    }
    
    // Desregistrar e sair da reunião
    await safeUnregisterMeeting();
    
    if (currentMeeting) {
      await currentMeeting.leave();
      currentMeeting = null;
    }
    
    console.log('✅ Hangup completed successfully');
    showConsultationEndedScreen();
  } catch (error) {
    console.error('❌ Error during hangup:', error);
    showConsultationEndedScreen();
  }
}

function showConsultationEndedScreen() {
  // Esconder controles
  const controls = document.getElementById('controls');
  if (controls) {
    controls.style.display = 'none';
  }
  
  // Esconder modal de confirmação
  hideHangupConfirmation();
  
  // Mostrar tela de encerramento
  const closedMeeting = document.getElementById('closed-meeting');
  if (closedMeeting) {
    closedMeeting.classList.remove('hidden');
    closedMeeting.classList.add('animate-fade-in');
    
    // Atualizar duração
    const durationElement = document.getElementById('consultation-duration');
    if (durationElement) {
      durationElement.textContent = getConsultationDuration();
    }
  }
}

function reloadIframe() {
  console.log('🔄 Reloading iframe...');
  window.location.reload();
}

// Event listeners para os novos botões
document.addEventListener('DOMContentLoaded', function() {
  // Botão cancelar hangup
  const cancelHangupBtn = document.getElementById('cancel-hangup');
  if (cancelHangupBtn) {
    cancelHangupBtn.addEventListener('click', hideHangupConfirmation);
  }
  
  // Botão confirmar hangup
  const confirmHangupBtn = document.getElementById('confirm-hangup');
  if (confirmHangupBtn) {
    confirmHangupBtn.addEventListener('click', async () => {
      hideHangupConfirmation();
      await performHangup();
    });
  }
  
  // Botão reconectar à consulta
  const resumeConsultationBtn = document.getElementById('resume-consultation-btn');
  if (resumeConsultationBtn) {
    resumeConsultationBtn.addEventListener('click', reloadIframe);
  }
});

initializeWebex();
